import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M10.667.314v31.372c-1.733-.204-3.255-.508-4.325-.916C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.318.863-8.109 0 0 1.03-4.918 5.476-6.646C7.412.821 8.934.518 10.667.314m10.667 31.384V.318c1.738.207 3.27.52 4.357.945 4.447 1.728 5.476 6.646 5.476 6.646.664 2.757.863 5.582.83 8.107.033 2.493-.2 5.317-.863 8.108 0 0-1.029 4.918-5.477 6.646-1.07.425-2.59.728-4.323.928",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M21.333.318v31.38c-1.654.19-3.502.286-5.333.302a51 51 0 0 1-5.334-.314V.314A51 51 0 0 1 16 0c1.83.016 3.676.12 5.333.318",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "M12 16.314a3.98 3.98 0 0 0 2.461 3.675.334.334 0 0 1-.255.616 4.638 4.638 0 0 1-.718-8.208.333.333 0 0 1 .358.562A3.97 3.97 0 0 0 12 16.314m8 0a3.97 3.97 0 0 0-1.846-3.355.333.333 0 0 1 .359-.562 4.638 4.638 0 0 1-.718 8.208.333.333 0 0 1-.256-.616A3.98 3.98 0 0 0 20 16.314",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M17.061 13.683c-.435-.53-.79-.93-1.532-1.19.001-.003.303-.413-.126-.491s-.403.357-.247.48c-.078.124-.227.838.408 1.201.594.34 1.24.172 1.247.146.507.518 1.568 3.607-.54 6.14 1.412-.975 2.441-4.25.79-6.286",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F9F0AA",
      fillRule: "evenodd",
      d: "M14.047 14.755a1.5 1.5 0 0 1-.047-.273c-.002-.155.145-.442.348-.461a66 66 0 0 1 2.472-.006c.174.153.23.46.13.66.701.976 1.534 2.714.703 3.157-.281-.011-2.92.176-3.143.151 0 0-.244-.152-.29-.407-.057-.312.15-.527.277-.537.09-.01.432-.039.432-.039s-.867-2.197-.883-2.245",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagGtm = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagGtm_default = SvgFlagGtm;

export { FlagGtm_default as default };
